import React from 'react';

function PlotText({ x, y, children, offset, ...props }) {
  return (
    <text x={x + offset.x} y={y + offset.y} className="small" {...props}>{children}</text>
  );
}

PlotText.defaultProps = {
  offset: {
    x: 0,
    y: 0,
  },
}

export default PlotText;



// WEBPACK FOOTER //
// ./src/components/PlotText/index.js